import formatRFC3339 from 'date-fns/formatRFC3339';

import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';


const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)
  .then((response) => {
    if (!response.ok) {
      throw Error(response?.statusText || 'An Unexpected error has occurred.')
    }
    return response.json()
  })

export const fetchAssays = (queryParams) => {
  const [pipeline_id, workspace_id, filterObj, dateObj] = queryParams;
  const params = {
    pipeline_id,
    workspace_id,
  }

  if (filterObj) {
    params.name = filterObj?.name;
    params.active = filterObj?.active;
    params.sort_by = filterObj?.sortBy || 'CreationDateDesc';
    params.drift_detected = filterObj?.driftDetected;
  }

  if (dateObj?.start && dateObj?.end) {
    params.drift_window = {
      start: dateObj?.start ? formatRFC3339(dateObj?.start) : undefined,
      end: dateObj?.end ? formatRFC3339(dateObj?.end) : undefined,
    };
  } 

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(params),
  };

  return postToApi('v1/api/assays/filter', fetchOptions)
}

export default fetchAssays;
